import {
    DEPLOYMENT_DATA,
} from "./actionTypes";

export const setDeploymentData = deploymentData =>({
    type: DEPLOYMENT_DATA,
    payload: {
        deploymentData
    }
});